import React,{Component} from 'react';
import {
  Row,
  Col
} from 'reactstrap';

import Form from '../../../shared/components/Form';
import Button from '../../../shared/components/Button';
import ColorInput from '../../../shared/components/ColorInput';
import DroppableFileInput from '../../../shared/components/DroppableFileInput';
import TextInput from '../../../shared/components/TextInput';
// import { divideArrayIntoNGroups } from '../../shared/utils';

class RetailerInfo extends Component {
  constructor(){
    super();

    this.state = {
      color:null,
      logo:null,
      isSaving:false
    };
  }

  handleSubmit(data){

    const {color,logo} = this.state;

    const {
        isCreate,
        accountId,
        retailerId,
        createRetailer,
        updateRetailer
      } = this.props;

    if(color) data.primaryColor = color;
    if(accountId) data.agencyId = accountId;
    if(logo){
      data.logoId = logo.id;
      data.logoURL = logo.large;
      data.logoThumbnailURL = logo.thumbnail;
      data.logoFileName = logo.fileName;
    }

    if(isCreate){
      this.setState({isSaving:true});

      data.isBrand = false;

      createRetailer(data)
        .then((res) => this.handleCreateSuccess(res))
        .then(() => this.setState({isSaving:false}))
        .catch((err) => this.handleError(err))

    } else {
      this.setState({isSaving:true});

      Promise.all([
        updateRetailer(retailerId,data)
      ])
        .then(() => this.handleSuccess())
        .then(() => this.setState({isSaving:false}))
        .catch((err) => this.handleError(err))
    }
  }

  handleCreateSuccess(res){
    this.props.history.push(`/superadmin/retailers/${res.instance.id}/edit`);
  }

  handleSuccess(){}

  handleError(err){}

  getSaveButtonText(){
    const isCreate = this.props.isCreate,
      isSaving = this.state.isSaving;

    if(isCreate && isSaving) return 'Creating Retailer';
    if(isCreate && !isSaving) return 'Create Retailer';
    if(!isCreate && isSaving) return 'Updating Retailer';
    if(!isCreate && !isSaving) return 'Update Retailer';

    return 'Save';
  }

  render(){
    const {
      isCreate,
      name,
      logoURL,
      primaryColor,
      logoFileName
      // agencies,
      // retailers,
      // currentApprovedRetailers
    } = this.props;

    const {
      logo
    } = this.state;

    return (
      <Form onSubmit={(data) => this.handleSubmit(data)}>
        <Row>
          <Col xs='12' md='6'>
            {isCreate && (
              <div>
                <br />
                <h3>New Publisher</h3>
                <br />
              </div>
            )}
            <TextInput 
              name='name'
              label='Name'
              defaultValue={name}
              placeholder={'ACME inc'}
              maxLength={40}
            />
            <DroppableFileInput 
              label='Logo Image'
              text='Upload logo image'
              fileType='image'
              onChange={(logo) => this.setState({logo:logo})}
              cropperAspectRatio={1/1}
              existingFileName={logo ? logo.fileName : logoFileName}
              existingFileURL={logo ? logo.large : logoURL}
            />
            <ColorInput
              label='Primary Color'
              name='primaryColor'
              defaultValue={primaryColor}
              placeholder='#FF00FF'
              onChange={(color) => this.setState({color:color})}
            />
            <br />
            <Button isSubmit>
              {this.getSaveButtonText()}
            </Button>
            <br />
            <br />
          </Col>
        </Row>
      </Form>
    )
  }
}

RetailerInfo.defaultProps = {
  isCreate:false
};

export default RetailerInfo;



// WEBPACK FOOTER //
// ./src/routes/RetailerInfo/components/RetailerInfo.js